// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";


// HRニューススライド保存（新規/更新）
const AdminHrNewsSaveApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/hr_news_save";

    const ExecAdminHrNewsSaveApi = async (params) => {
        const requestParams = {
            id: params.id || 0,
            banner_path: params.banner_path || "",
            card_text: params.card_text || "",
            url: params.url || "",
            description: params.description || "",
            start_date: params.start_date,
            end_date: params.end_date,
        };

        let response = null;
        let error = null;
        try {
            response = await ApiRequest({ url, requestParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminHrNewsSaveApi;
};

export default AdminHrNewsSaveApi;
